import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation } from "@tanstack/react-query";

export const NOTIFICATION_TEST_RESOURCE = "notification" as const;
export const NOTIFICATION_TEST_API_PATH = `/v1/${NOTIFICATION_TEST_RESOURCE}/test` as const;

export type NotificationTestSendBody =
  paths[typeof NOTIFICATION_TEST_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type NotificationTestSendResponse =
  paths[typeof NOTIFICATION_TEST_API_PATH]["post"]["responses"][201]["content"]["application/json"];

export const useNotificationTestSendMutation = () => {
  return useMutation<NotificationTestSendResponse, Error, NotificationTestSendBody>({
    mutationFn: async (body: NotificationTestSendBody) => {
      const response = await alphartisApiAxios.post<NotificationTestSendResponse>(NOTIFICATION_TEST_API_PATH, body);
      return response.data;
    },
  });
};
